import React, { useEffect } from "react";
import {
  View,
  Text,
  ImageBackground,
  Image,
  Keyboard,
  TouchableWithoutFeedback,
  Platform,
  Pressable,
} from "react-native";
import useRegister from "@lib/hooks/register/useRegister";
// @ts-ignore
import EventBus from "react-native-event-bus";
import Constants, {
  getCompanyName,
  isGradientAllowed,
  ScreenNameList,
} from "@lib/utilities/Constants";
import { BRANDING_BACKGROUND_IMAGE, LOGO } from "../../resources/IMAGES";

import RegisterSuccessView from "../../components/register/RegisterSuccessView";
import CustomAlert from "../../components/common/CustomAlert";
import { ids, styles } from "./Style";

import commonStyle from "../../assets/styles/common-style";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import {
  LOGIN_ROUTE,
  REGISTER_ROUTE,
} from "../../navigation/NavigationConstants";
import UserDetailForm from "../../components/register/UserDetailForm";
import PasswordForm from "../../components/register/PasswordForm";
import KeyboardScrollWrapper from "../../components/common/KeyboardAvoidingViewWrapper";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { messages } from "../../resources/strings";
import GradientBackground from "../../components/gradient-background/GradientBackground";

const RegisterView = ({ navigation }: any) => {
  const {
    errorHandle,
    isLoading,
    firstName,
    lastName,
    email,
    phone,
    validateFirstName,
    validateLastName,
    validateEmail,
    validatePhone,
    password,
    confirmPassword,
    firstNameHelpText,
    lastNameHelpText,
    emailHelpText,
    passwordHelpText,
    confirmPasswordHelpText,
    phoneHelpText,
    showPassword,
    isInitialStep,
    isInitialSubmit,
    isFinalSubmit,
    isRegistered,
    headerLabel,

    showPasswordLabel,
    showConfirmPassword,
    showConfirmPasswordLabel,
    isVerifyEmail,
    setConfirmPassword,
    setErrorHandle,
    checkSession,

    validatePassword,
    matchPasswords,
    togglePasswordVisiblity,
    toggleConfirmPasswordVisiblity,
    registerNewUser,
    submitInitialForm,
    listener,
  } = useRegister();

  useEffect(() => {
    Crashlytics.logScreen(REGISTER_ROUTE);
    checkSession();
    EventBus.getInstance().addListener(
      Constants.Events.LOGIN_SUCCESS,
      listener,
    );

    return () => {
      EventBus.getInstance().removeListener(listener);
    };
  }, []);
  useEffect(() => {
    if (Platform.OS == "web" && getCompanyName() == "HCPCI") {
      navigation.navigate(LOGIN_ROUTE as never);
    }
  }, []);
  const FormContainer =
    Platform.OS !== "web" ? Pressable : TouchableWithoutFeedback;

  let Content = () => (
    <>
      <KeyboardScrollWrapper>
        <FormContainer
          onPress={() => {
            if (Platform.OS !== "web") {
              Keyboard.dismiss();
            }
          }}
          style={styles.mainContainer}
        >
          <>
            {!isRegistered && (
              <View style={styles.mainContainer}>
                <View
                  style={[styles.logoBlock]}
                  dataSet={{ media: ids.logoBlock }}
                  testID="register-page-brand-logo-container"
                >
                  <Image
                    style={styles.Logo}
                    dataSet={{ media: ids.Logo }}
                    source={LOGO}
                    resizeMode={"contain"}
                    testID="register-page-brand-logo"
                  />
                </View>
                <View
                  style={[styles.formBlock]}
                  dataSet={{ media: ids.formBlock }}
                >
                  <Text
                    style={[styles.headingText]}
                    dataSet={{ media: ids.headingText }}
                    testID="register-page-header-label"
                  >
                    {headerLabel}
                  </Text>
                  {isInitialStep ? (
                    <UserDetailForm
                      firstName={firstName}
                      lastName={lastName}
                      email={email}
                      phone={phone}
                      firstNameHelpText={firstNameHelpText}
                      lastNameHelpText={lastNameHelpText}
                      emailHelpText={emailHelpText}
                      phoneHelpText={phoneHelpText}
                      validateFirstName={validateFirstName}
                      validateLastName={validateLastName}
                      validateEmail={validateEmail}
                      validatePhone={validatePhone}
                      isInitialSubmit={isInitialSubmit}
                      submitInitialForm={submitInitialForm}
                    />
                  ) : (
                    <PasswordForm
                      password={password}
                      confirmPassword={confirmPassword}
                      passwordHelpText={passwordHelpText}
                      confirmPasswordHelpText={confirmPasswordHelpText}
                      showPasswordLabel={showPasswordLabel}
                      showConfirmPasswordLabel={showConfirmPasswordLabel}
                      showConfirmPassword={showConfirmPassword}
                      showPassword={showPassword}
                      validatePassword={validatePassword}
                      matchPasswords={matchPasswords}
                      toggleConfirmPasswordVisiblity={
                        toggleConfirmPasswordVisiblity
                      }
                      togglePasswordVisiblity={togglePasswordVisiblity}
                      setConfirmPassword={setConfirmPassword}
                      isFinalSubmit={isFinalSubmit}
                      registerNewUser={registerNewUser}
                    />
                  )}
                </View>
              </View>
            )}
            {isRegistered && (
              <RegisterSuccessView
                onNoInternet={() => {
                  setErrorHandle(messages.error.youAreOffline);
                }}
                email={email}
                verifyEmail={isVerifyEmail}
                screenName={ScreenNameList.register}
                navigation={navigation}
              />
            )}

            {errorHandle != messages.error.noError ? (
              <View style={commonStyle.styles.errorView}>
                <CustomAlert
                  data={{
                    message: errorHandle,
                    screenName: ScreenNameList.register,
                  }}
                  onEndTimer={() => {
                    setErrorHandle(messages.error.noError);
                  }}
                />
              </View>
            ) : null}
          </>
        </FormContainer>
      </KeyboardScrollWrapper>
      {isLoading && <FullScreenLoader screenName={ScreenNameList.register} />}
    </>
  );

  if (isGradientAllowed && Platform.OS !== "web") {
    return (
      <GradientBackground
        styles={[styles.bgImg]}
        testID="register-page-container-gradient"
      >
        {Content()}
      </GradientBackground>
    );
  }
  return (
    <ImageBackground
      source={BRANDING_BACKGROUND_IMAGE}
      style={[styles.bgImg, isGradientAllowed && styles.gradientBg]}
      imageStyle={{
        resizeMode: "cover",
      }}
      testID="register-page-container-image"
    >
      {Content()}
    </ImageBackground>
  );
};

export default RegisterView;
